import React, { Component } from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
} from '@material-ui/core';

const SelectedTab = styled.div`
  border: 1px solid white;
  border-bottom: none;
  border-radius: 4px;
  background: transparent;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  margin-left: 5px;
  font-family: ProximaNovaBold;
  font-size: 12px;
  background: ${props => props.color || '#3c4251'};
  color: white;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  z-index: 1;
  min-height: 40px;
`;
const TabButton = styled(Button).attrs({
  style: ({ color }) => ({
    background: `${color || '#3f1717'}`
  })
})`
  && {
    color: white;
    margin-left: 5px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    font-family: ProximaNovaLight;
    font-size: 12px;
    font-weight: bold;
    min-height: 24px;
    min-width: fit-content;

    &:hover {
      background-color: rgba(181, 173, 173, 0.08);
    }
  }
`;
const TabContent = styled.div`
  border: 1px solid ${props => props.color || '#3c4251'};
  border-radius: 4px;
  background: transparent;
  min-height: 300px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  min-width: fit-content;
  height: calc(100% - 40px);
`;

const styles = theme => ({
  flexBox: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    fontSize: 8,
    minWidth: 'fit-content',
  },
});

class Tabs extends Component {

  render() {
    const { classes, tabs, value, wrapStyle, onChange, children, name, color, colors } = this.props;
    let borderColor = color;

    if (colors !== undefined) {
      borderColor = colors[value]
    }

    return (
      <div className={classes.container} style={wrapStyle}>
        <div className={classes.flexBox}>
          <div className={classes.flexBox}>
            {
              tabs.map((tab, id) => {
                let backColor = color

                if (colors !== undefined)
                  backColor = colors[id]
                if (value === id) return <SelectedTab color={backColor}>{tab}</SelectedTab>;
                return (
                  <TabButton
                    key={id}
                    color={backColor}
                    onClick={(ev) => onChange(name, id)}>{tab}
                  </TabButton>
                )
              })
            }
          </div>
        </div>
        <TabContent color={borderColor}>
          {children}
        </TabContent>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Tabs);